<template>
  <v-container>
    <component :is="getSimComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/magazzino/sims/Index'
  import Insert from './../components/magazzino/sims/Insert'

  export default {
    name: 'MagazzinoSims',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getSimComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_SIM_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_SIM_COMPONENT('Index')
    }
  }
</script>

<style>
</style>